import React from 'react';
import { useStaticQuery, graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks, mergeBlocks} from "../../../services/builder";
import styles from "./styles";

const useStyles = makeStyles(theme => styles(theme));

export const BblImageContentRowsInnerBlock = (props) => {

    const data = useStaticQuery(graphql`
        query imageContentRowsInnerQuery {
            wp {
                themeOptions {
                    ThemeOptions {
                        imageContentRow {
                            backgroundColour
                            headerColour
                            paragraphColour
                        }
                    }
                }
            }
        }`);

    let overrides = data.wp.themeOptions.ThemeOptions.imageContentRow;

    if(props.innerBlocks[1].attributes.textColor === "" && overrides.headerColour !== 'on-primary') {
        props.innerBlocks[1].attributes.textColor = overrides.headerColour;
    }

    if(props.innerBlocks[2].attributes.textColor === "" && overrides.paragraphColour !== 'on-primary') {
        props.innerBlocks[2].attributes.textColor = overrides.paragraphColour;
    }

    const mergedBlocks = mergeBlocks(props.innerBlocks, props.block.innerImage);
    const blocks = buildBlocks(mergedBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();
    
    return <div className={`inner ${props.attributes.className ? props.attributes.className : ''} ${classes.imageContentRowsInner} `}
                data-override-background={overrides.backgroundColour !== 'primary' ? overrides.backgroundColour : null}
    >
        <div className="image-wrap">
            {blocks[0]}
        </div>
        <div className="con-wrap">
            {blocks[1]}
            {blocks[2]}
            {blocks[3]}
        </div>
    </div>
};

export const BblImageContentRowsInnerBlockFragment = graphql`
  fragment BblImageContentRowsInnerBlock on WpBlock {
    ... on WpBblImageContentRowsInnerBlock {
        name
        attributes {
            ... on WpBblImageContentRowsInnerBlockAttributes {
                className
            }
        }
        innerImage: innerBlocks {
            ... on WpCoreImageBlock {
                name
                originalContent
                attributes {
                  __typename
                  ... on WpCoreImageBlockAttributes {
                    url     
                    alt
                    localFile {
                      publicURL
                      childImageSharp {
                          gatsbyImageData(
                            width: 1024,
                            aspectRatio: 1,
                            placeholder: BLURRED,
                            formats: [AUTO, WEBP, AVIF],
                            transformOptions: {fit: COVER, cropFocus: CENTER},
                            quality: 90
                          )
                      }
                    }
                  }
                }
            }            
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const BblImageContentRowsInnerBlockPreview = `
    ... on BblImageContentRowsInnerBlock {
        name
        attributes {
            ... on BblImageContentRowsInnerBlockAttributes {
                className
            }
        }
    }
`;